<template>
    <div v-if="profData">
        <professional-base-info-block :profId="profData.profId" :centerId="profData.centerId" :rating="profData.rating" :isFavourite="profData.isFavourite" :customPageUrl="profData.customPageUrl" :name="profData.name" :surnames="profData.surnames" :specialties="profData.specialties" :introductoryText="profData.introductoryText"
            :languages="profData.languages" :photoUri="profData.photoUri" :gender="profData.gender" :subspecialties="profData.subspecialties" @toggleIsFavourite="profData.isFavourite = $event" :searchDisabled="profData.searchDisabled"></professional-base-info-block>
        <availability-request-modal v-model="showAvailabilityRequestForm" :profId="profId" :appointmentTypeSelected="type" :specialties="profData.specialties" :companyServices="companyServices" noClose goRoot></availability-request-modal>
        <budget-request-modal v-model="showBudgetRequestForm" :profId="profId" noClose></budget-request-modal>
    </div>
  </template>
  
<script>
  import { INPLACE, WRITTEN, CHAT, VIDEO, IMMEDIATE_VIDEO, CALL, AT_HOME, APPOINTMENT_REQUEST_TYPES } from '@/constants/consultationTypes'
  import ProfessionalBaseInfoBlock from '@/components/shared/ProfessionalBaseInfoBlock.vue'
  import AvailabilityRequestModal from '@/components/shared/AvailabilityRequestModal.vue'
  import BudgetRequestModal from '@/components/shared/BudgetRequestModal.vue'
  import searchRepository from '@/repositories/SearchRepository'
  import patientsRepository from '@/repositories/PatientsRepository'

  const BUDGET_ROUTE_NAME = 'budgetRequest'
  
  export default {
    components: {
        ProfessionalBaseInfoBlock,
        AvailabilityRequestModal,
        BudgetRequestModal
    },
    data () {
      return {
        profData: null,
        patientInfo: null,
        type: null,
        profId: null,
        showAvailabilityRequestForm: false,
        showBudgetRequestForm: false
      }
    },
    created () {
      this.init()
    },
    computed: {
        companyServices () {
            if (this.patientInfo && this.patientInfo.validCode && this.profData && this.profData.patientCompanyServices) {
                return {
                    [IMMEDIATE_VIDEO]: this.profData.patientCompanyServices.indexOf(IMMEDIATE_VIDEO) > -1,
                    [VIDEO]: this.profData.patientCompanyServices.indexOf(VIDEO) > -1,
                    [WRITTEN]: this.profData.patientCompanyServices.indexOf(WRITTEN) > -1,
                    [CHAT]: this.profData.patientCompanyServices.indexOf(CHAT) > -1,
                    [INPLACE]: this.profData.patientCompanyServices.indexOf(INPLACE) > -1,
                    [CALL]: this.profData.patientCompanyServices.indexOf(CALL) > -1,
                    [AT_HOME]: this.profData.patientCompanyServices.indexOf(AT_HOME) > -1
                }
            } else {
                return {
                    [IMMEDIATE_VIDEO]: false,
                    [VIDEO]: false,
                    [WRITTEN]: false,
                    [CHAT]: false,
                    [INPLACE]: false,
                    [CALL]: false,
                    [AT_HOME]: false
                }
            }
        }
    },
    methods: {
      init () {
        this.profId = this.$route.query.profId
        searchRepository.getProfessionals({ userId: this.profId }).then((response) => {
            if (response.data.data) {
                this.profData = response.data.data[0]
            }
        })
        if (this.$router.currentRoute.name === BUDGET_ROUTE_NAME) {
          this.initBudgetRequestModal()
        } else {
          this.initAvailabilityRequestModal()
        }
      },
      initAvailabilityRequestModal () {
        this.type = this.$route.query.type ? APPOINTMENT_REQUEST_TYPES[this.$route.query.type] : null
        this.showAvailabilityRequestForm = true
        patientsRepository.getPatientInfo().then(response => {
            if (response.data) {
                this.patientInfo = response.data || {}
            }
        })
      },
      initBudgetRequestModal () {
        this.showBudgetRequestForm = true
      }
    }
  }
</script>
  
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/availability-request/AvailabilityRequestView.vue